export default "__VITE_PUBLIC_ASSET__83139bad__"